<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-account-edit</v-icon>
              <span class="headline font-weight-bold">Editar Atendente</span>
            </v-card-title>

            <v-divider class="mb-4"></v-divider>

            <v-card-text>
              <v-form ref="form" v-model="valid" @submit.prevent="submit">
                <v-text-field
                  v-model="login"
                  label="Login"
                  disabled
                  outlined
                  prepend-icon="mdi-account"
                  class="mb-4"
                ></v-text-field>

                <v-text-field
                  v-model="nome"
                  label="Nome completo"
                  outlined
                  :rules="nameRules"
                  prepend-icon="mdi-card-account-details"
                  class="mb-4"
                  required
                ></v-text-field>

                <v-checkbox
                  v-model="checkboxSenha"
                  label="Alterar senha?"
                  class="mt-0"
                ></v-checkbox>

                <v-slide-y-transition>
                  <v-text-field
                    v-if="checkboxSenha"
                    v-model="senha"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showPassword ? 'text' : 'password'"
                    label="Nova senha"
                    outlined
                    :rules="checkboxSenha ? senhaRules : []"
                    prepend-icon="mdi-lock"
                    counter
                    @click:append="showPassword = !showPassword"
                    class="mb-4"
                  ></v-text-field>
                </v-slide-y-transition>

                <v-alert
                  v-model="erroLogin"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Username já está em uso!
                </v-alert>

                <v-alert
                  v-model="sucessoLogin"
                  color="success"
                  icon="mdi-check-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Dados do atendente atualizados com sucesso!
                </v-alert>

                <v-card-actions class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    rounded
                    depressed
                    type="submit"
                    :disabled="!valid"
                    :loading="loading"
                    class="px-6"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar Alterações
                  </v-btn>

                  <v-btn
                    to="/listaAtendentesUnidade"
                    large
                    outlined
                    rounded
                    color="grey darken-1"
                    class="ml-2"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Voltar
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'EditarAtendenteUnidade',
  data () {
    return {
      showPassword: false,
      valid: false,
      loading: false,
      tipo: 3,
      login: '',
      idLocalEscolhida: '',
      erroLogin: false,
      sucessoLogin: false,
      senha: '',
      nome: '',
      username: '',
      checkboxSenha: false,
      senhaRules: [
        v => !!v || 'Senha é obrigatória',
        v => (v && v.length >= 5) || 'Senha deve ter pelo menos 5 caracteres'
      ],
      nameRules: [
        v => !!v || 'Nome é obrigatório',
        v => (v && v.length >= 5) || 'Nome deve ter pelo menos 5 caracteres'
      ]
    }
  },
  methods: {
    async submit () {
      if (!this.$refs.form.validate()) return

      this.loading = true
      this.erroLogin = false
      this.sucessoLogin = false

      // Clear password if checkbox is not selected
      const senhaParaEnviar = this.checkboxSenha ? this.senha : ''

      try {
        const response = await administradorUnidadeService.administradorUnidade.alterarFuncionario(
          this.idLocalEscolhida,
          this.nome,
          this.tipo,
          this.username,
          senhaParaEnviar,
          ''
        )

        if (response.data === 'usernameExistente') {
          this.erroLogin = true
          return
        }

        if (response.data === true) {
          this.sucessoLogin = true
          setTimeout(() => {
            this.$router.push('/listaAtendentesUnidade')
          }, 1500)
        }
      } catch (error) {
        console.error('Erro ao atualizar atendente:', error)
        this.erroLogin = true
      } finally {
        this.loading = false
      }
    },
    limpar () {
      this.senha = ''
      this.nome = ''
    }
  },
  computed: {
    user () {
      return this.$store.getters.usuario
    }
  },
  mounted () {
    if (!this.$route.params.item) {
      this.$router.push('/listaAtendentesUnidade')
      return
    }

    const { username, nome, idLocal } = this.$route.params.item
    this.username = username
    this.nome = nome
    this.idLocalEscolhida = idLocal
    this.login = username
  }
}
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-btn {
  letter-spacing: normal;
  text-transform: none;
}

.v-btn--disabled {
  opacity: 0.6;
}
</style>
